import { clsx } from 'clsx';
import { CALLOUT_COLORS } from "./constants";
import { CalloutIcon } from "./ui/CalloutIcon";
import { CalloutInformation } from "./ui/CalloutInformation";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Callout = function Callout(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    textLink = _ref.textLink,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'informative' : _ref$type,
    className = _ref.className,
    noClamp = _ref.noClamp,
    full = _ref.full,
    rounded = _ref.rounded,
    fill = _ref.fill;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(className || 'tw-w-[32.8rem] sm:tw-w-[38rem] tw-flex tw-items-start'),
    children: [!rounded && /*#__PURE__*/_jsx("div", {
      className: clsx('tw-rounded-l-1 tw-h-full tw-w-0.4 tw-shrink-0', CALLOUT_COLORS[type].leftBorder.light, CALLOUT_COLORS[type].leftBorder.dark)
    }), /*#__PURE__*/_jsxs("div", {
      className: clsx(' tw-border-solid tw-py-1.2 tw-px-1.6 tw-flex dark:tw-bg-elevation-dark-03', rounded ? CALLOUT_COLORS[type].background : 'tw-bg-neutral-light-100', rounded ? CALLOUT_COLORS[type].allBorders : CALLOUT_COLORS[type].otherBordersDark, full && 'tw-w-full', fill && 'tw-border-none'),
      children: [/*#__PURE__*/_jsx("div", {
        className: clsx('tw-w-2 ', rounded ? 'tw-flex tw-mr-1 tw-items-center tw-justify-center' : 'tw-mr-0.8'),
        children: /*#__PURE__*/_jsx(CalloutIcon, {
          type: type
        })
      }), /*#__PURE__*/_jsx(CalloutInformation, {
        title: title,
        subtitle: subtitle,
        textLink: textLink,
        type: type,
        noClamp: noClamp,
        rounded: rounded
      })]
    })]
  });
};